import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';


export default class PluginConfiguration extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        enableSave: PropTypes.func,
        disableSave: PropTypes.func
    };

    static defaultProps = {
        configuration: null
    };

    constructor(props) {
        super(props);

        let configuration = props.configuration || {};

        this.state = {
            iframeUrl: configuration.iframeUrl ? configuration.iframeUrl : ''
        };
    }

    componentDidMount() {
        this.validateUrl(this.state.iframeUrl);
    }

    onChangeIFrameUrl(iframeUrl) {
        this.validateUrl(iframeUrl);
        this.setState({
            iframeUrl: iframeUrl
        });
    }

    getConfiguration() {
        return {iframeUrl: this.state.iframeUrl};
    };

    validateUrl(url) {
        if (this.isValidUrl(url)) {
            this.props.enableSave();
        } else {
            this.props.disableSave();
        }
    }

    isValidUrl(iframeUrl) {
        // add real validation later...
        return iframeUrl.length > 0;
    }

    render() {
        return (
            <div>
                <TextField
                    className="custom-field"
                    fullWidth={true}
                    floatingLabelText="IFrame URL"
                    floatingLabelFixed={true}
                    hintText="Enter URL for the iframe"
                    value={this.state.iframeUrl}
                    type="url"
                    onChange={event => this.onChangeIFrameUrl(event.target.value)}
                />
            </div>
        );
    }

};



// WEBPACK FOOTER //
// ./src/components/plugins/iframePlugin/PluginConfiguration.js